import axios from "axios";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import deepCopy from "../../../../utils/deepcopy.js";
import "./index.css";
import EnhancedTable from "../../components/EnhancedTable.jsx";
import {
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { updateAdminModels, updateAlert } from "../../redux/actions.js";
import getDate from "../../../../utils/getDate.js";

function ModelPanel(props) {
  const [models, setModels] = useState([]);
  const [modelOpen, setModelOpen] = useState(false);
  const [selectedModel, setSelectedModel] = useState({});
  const [modelReload, setModelReload] = useState(false);
  const [searchModels, setSearchModels] = useState([]);
  const [modelReject, setModelReject] = useState(false);
  const [modelRejectReason, setModelRejectReason] = useState("");

  const modelHeadCells = [
    {
      id: "id",
      numeric: true,
      disablePadding: true,
      label: "ModelId",
      align: "center",
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Name",
      align: "left",
    },
    {
      id: "version",
      numeric: false,
      disablePadding: false,
      label: "Version",
      align: "center",
    },
    {
      id: "details",
      numeric: false,
      disablePadding: false,
      label: "Details",
      align: "left",
    },
    {
      id: "usernames",
      numeric: false,
      disablePadding: false,
      label: "Usernames",
      align: "left",
    },
    {
      id: "approveStatus",
      numeric: false,
      disablePadding: false,
      label: "Status",
      align: "center"
    }
  ];
  useEffect(() => {
    if (props.models === null || modelReload) {
      axios({
        method: "post",
        url: "/api/m2d/admin/getAllModels",
        data: {
          adminId: props.user.id
        }
      }).then(res => {
        const new_models = deepCopy(res.data)
        new_models.map(model => {
          const usernames = model.users.map(user => `${user.firstName} ${user.lastName}`)
          model.usernames = `${usernames[0]}${usernames.length > 1 ? ` and ${usernames.length - 1} others` : ''}`
          return model
        })

        setModels(new_models)
        props.handleModels(new_models)
        setModelReload(false)
      })
    } else {
      setModels(props.models)
    }
  }, [modelReload, props])

    // ---------- model functions ----------

    const handleClearModelSearch = () => {
      setSearchModels([])
    };
  
    const handleModelSearch = (name) => {
      setSearchModels(models.filter(model => model.name.includes(name)))
    }
  
    const handleModelEdit = (selected) => {
      setSelectedModel(selected)
      setModelOpen(true)
    }
  
    const handleModelClose = () => {
      setModelOpen(false)
      setSelectedModel({})
  
    }
  
    const handleModelApprove = () => {
      if (selectedModel.id !== undefined) {
        axios({
          method: "post",
          url: "/api/m2d/admin/approveModel",
          data: {
            adminId: props.user.id,
            mid: selectedModel.id
          }
        }).then(() => {
          setModelOpen(false)
          setModelReload(!modelReload)
          props.handleAlert("success", "Successfully approved!")
        }).catch(err => {
          console.log(err)
          props.handleAlert("error", err.message)
        })
      }
    }
  
    const handleModelReject = () => {
      if (!modelReject || !modelRejectReason) {
        setModelReject(true)
      } else {
        // handle reject
        if (selectedModel.id !== undefined) {
          axios({
            method: "post",
            url: "/api/m2d/admin/rejectModel",
            data: {
              adminId: props.user.id,
              mid: selectedModel.id,
              rejectReason: modelRejectReason
            }
          }).then(() => {
            setModelOpen(false)
            setModelReject(false)
            setModelRejectReason("")
            setSelectedModel({})
            setModelReload(!modelReload)
            props.handleAlert("success", "Successfully rejected!")
          }).catch(err => {
            console.log(err)
            props.handleAlert("error", err.message)
          })
        }
      }
    }
  
    const handleModelCancel = () => {
      if (!modelReject) {
        handleModelClose()
      } else {
        setModelReject(false)
        setModelRejectReason("")
      }
    }
  
    const handleModelRejectReasonChange = (e) => {
      setModelRejectReason(e.target.value)
    }

  return (
    <>
      <EnhancedTable
        title="Models"
        headCells={modelHeadCells}
        rows={searchModels.length > 0 ? searchModels : models}
        handleEdit={handleModelEdit}
        handleSearch={handleModelSearch}
        handleClearSearch={handleClearModelSearch}
        search="Search by name"
      />
      {/* ---------- edit model ---------- */}
      <Dialog open={modelOpen} onClose={handleModelClose} >
        <DialogTitle>{selectedModel.name}</DialogTitle>
        <DialogContent sx={{ minWidth: '500px' }}>
          {selectedModel.date ? (
            <DialogContentText>
              <b>Date:</b> {getDate(selectedModel.date)}
            </DialogContentText>
          ) : null}
          <DialogContentText>
            <b>Name:</b> {selectedModel.name} v{selectedModel.version}
          </DialogContentText>
          <DialogContentText>
            <b>Details:</b> {selectedModel.Details}
          </DialogContentText>
          <DialogContentText>
            <b>Intended use:</b> {selectedModel.intendedUse ? selectedModel.intendedUse : 'None'}
          </DialogContentText>
          <DialogContentText>
            <b>Factors:</b> {selectedModel.factors ? selectedModel.factors : 'None'}
          </DialogContentText>
          <DialogContentText>
            <b>Training data:</b> {selectedModel.trainingData ? selectedModel.trainingData : 'None'}
          </DialogContentText>
          <DialogContentText>
            <b>Evaluation data:</b> {selectedModel.evalData ? selectedModel.evalData : 'None'}
          </DialogContentText>
          <DialogContentText>
            <b>Ethical considerations:</b> {selectedModel.ethicalConsid ? selectedModel.ethicalConsid : 'None'}
          </DialogContentText>
          <DialogContentText>
            <b>Caveats and recommendations:</b> {selectedModel.caveatsRecs ? selectedModel.caveatsRecs : 'None'}
          </DialogContentText>
          <DialogContentText>
            <b>License:</b> {selectedModel.license ? selectedModel.license : 'None'}
          </DialogContentText>
          <DialogContentText>
            <b>Data description:</b> {selectedModel.dataDescription ? selectedModel.dataDescription : 'None'}
          </DialogContentText>
          <DialogContentText>
            <b>User{selectedModel.users && selectedModel.users.length > 1 ? 's' : ''}:</b> {selectedModel.users ? selectedModel.users.map((user) => {
              return (
                <span key={user.id}>{user.firstName} {user.lastName} ({user.email}) </span>
              )
            }) : ''}
          </DialogContentText>

          {modelReject ? (
            <TextField
              margin="normal"
              id="name"
              label="Reject reason"
              type="username"
              fullWidth
              variant="outlined"
              value={modelRejectReason}
              multiline
              maxRows={5}
              onChange={handleModelRejectReasonChange}
            />
          ) : null}

        </DialogContent>
        <DialogActions sx={{ marginRight: "15px", marginBottom: "10px" }}>
          <Button variant="outlined" onClick={handleModelCancel}>Cancel</Button>
          <Button variant="outlined" color="error" onClick={handleModelReject}>Reject</Button>
          {modelReject ? null : (
            <Button variant="contained" onClick={handleModelApprove}>
              Approve
            </Button>
          )}

        </DialogActions>
      </Dialog>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
    models: state.m2d.adminModels,
    role: state.m2d.role
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },

    handleModels(models) {
      updateAdminModels(models)(dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModelPanel);
